
import { css } from 'lit';
export default css`
:host{
  --pc-icon-size-mobile-base:var(--spacing-3);
  --pc-icon-size-base:var(--spacing-4);

  --pc-icon-size-sm:var(--spacing-3);

  --pc-icon-size-mobile-lg:var(--spacing-4);
  --pc-icon-size-lg:var(--spacing-5);

  --pc-icon-size-mobile-xl:var(--spacing-5);
  --pc-icon-size-xl:var(--spacing-6);

  display:contents;
}

.icon{
  display:inline-flex;
  justify-content:center;
  align-items:center;
}

.icon svg{
  height:100%;
}

.icon.sm{
  width:var(--pc-icon-size-sm);
  height:var(--pc-icon-size-sm);
}

.icon.base:not(.is-fixed){
  width:var(--pc-icon-size-mobile-base);
  height:var(--pc-icon-size-mobile-base);
}

.icon.base.is-fixed{
  width:var(--pc-icon-size-base);
  height:var(--pc-icon-size-base);
}

.icon.lg:not(.is-fixed){
  width:var(--pc-icon-size-mobile-lg);
  height:var(--pc-icon-size-mobile-lg);
}

.icon.lg.is-fixed{
  width:var(--pc-icon-size-lg);
  height:var(--pc-icon-size-lg);
}

.icon.xl:not(.is-fixed){
  width:var(--pc-icon-size-mobile-xl);
  height:var(--pc-icon-size-mobile-xl);
}

.icon.xl.is-fixed{
  width:var(--pc-icon-size-xl);
  height:var(--pc-icon-size-xl);
}

@media (min-width: 992px){
  .icon.base:not(.is-fixed){
    width:var(--pc-icon-size-base);
    height:var(--pc-icon-size-base);
  }

  .icon.lg:not(.is-fixed){
    width:var(--pc-icon-size-lg);
    height:var(--pc-icon-size-lg);
  }

  .icon.xl:not(.is-fixed){
    width:var(--pc-icon-size-xl);
    height:var(--pc-icon-size-xl);
  }
}
`;